import axios from 'axios';
import Vue from 'vue';
import { Message } from 'element-ui';
import _get from 'lodash/get';
import _find from 'lodash/find';
import { errorCode } from './errorCode';
import config from '../config';
import { provinceMap, cityMap } from './gaodeMap';
import filters from '../filter/index';
import * as options from './optionMap';
import { administrativeAreas, municipality } from './administrativeAreas';
import lodashModel from 'lodash';
import { SITE_COLOR_DEFAULT } from './appConstant';
export const eventHub = new Vue();
/**
 * Cookie管理
 */
export const cookieManager = {
  getItem: key => {
    if (document.cookie.length > 0) {
      let c_name = key;
      let c_start = document.cookie.indexOf(c_name + '=');
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1;
        let c_end = document.cookie.indexOf(';', c_start);
        if (c_end == -1) c_end = document.cookie.length;
        return document.cookie.substring(c_start, c_end);
      }
    }
    return '';
  },
  setItem: (key, value, expires) => {
    let exdate = new Date();
    let path = config.cookie.default.path;
    // exdate.setDate(exdate.getDate() + expires);
    exdate.setTime(exdate.getTime() + expires * 24 * 60 * 60 * 1000);
    document.cookie =
      key +
      '=' +
      value +
      '; expires=' +
      exdate.toGMTString() /*  + ';path=' + path */;
  },
  removeItem: data => {
    let path = config.cookie.default.path;
    if (data instanceof Array) {
      for (let i in data) {
        document.cookie = data[i] + '= ;expires=-1' /*  + ';path=' + path */;
      }
    } else {
      document.cookie = data + '= ;expires=-1' /*  + ';path=' + path */;
    }
  }
};

export const bannerCookieManager = {
  getItem: key => {
    if (document.cookie.length > 0) {
      let c_name = key;
      let c_start = document.cookie.indexOf(c_name + '=');
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1;
        let c_end = document.cookie.indexOf(';', c_start);
        if (c_end == -1) c_end = document.cookie.length;
        return document.cookie.substring(c_start, c_end);
      }
    }
    return '';
  },
  setItem: (key, value, expires) => {
    let exdate = new Date();
    exdate.setTime(expires);
    document.cookie =
      key +
      '=' +
      value +
      '; expires=' +
      exdate.toGMTString() /*  + ';path=' + path */;
  },
  removeItem: data => {
    let path = config.cookie.default.path;
    if (data instanceof Array) {
      for (let i in data) {
        document.cookie = data[i] + '= ;expires=-1' /*  + ';path=' + path */;
      }
    } else {
      document.cookie = data + '= ;expires=-1' /*  + ';path=' + path */;
    }
  }
};
/**
 * 获取链接参数
 * @param {string} param - 参数名
 * @returns {any}
 */
export const getUrlParam = param => {
  let reg = new RegExp('(^|&)' + param + '=([^&]*)(&|$)'),
    r = window.location.search.substr(1).match(reg);
  if (r !== null) {
    return decodeURI(r[2]);
  } else {
    return null;
  }
};
export const getPathParam = (param, path) => {
  if (!path) {
    return null;
  }
  let reg = new RegExp('(^|&?)' + param + '=([^&]*)(&|$)'),
    r = path.match(reg);
  if (r !== null) {
    return decodeURI(r[2]);
  } else {
    return null;
  }
};

/* 得到相对位置 */

export const getElementLeft = element => {
  var actualLeft = element.offsetLeft;
  var current = element.offsetParent;
  while (current !== null) {
    actualLeft += current.offsetLeft;
    current = current.offsetParent;
  }
  return actualLeft;
};
export const getElementTop = element => {
  var actualTop = element.offsetTop;
  var current = element.offsetParent;
  while (current !== null) {
    actualTop += current.offsetTop;
    current = current.offsetParent;
  }
  return actualTop;
};
/* 得到不同角色的进入系统的index */
export const getLoginIndex = (role, isAgent) => {
  let index = '/search';
  if (role == 'agent' || role == 'admin') {
    index = '/user';
  }
  return index;
};
export const categorizeNumber = item => {
  let fixed = [];
  let mobile = [];
  if (/^1\d{10}$/.test(item) || /^https?/.test(item)) {
    mobile.push(item);
  } else {
    fixed.push(item);
  }
  return {
    fixed,
    mobile
  };
};

export const setItem = function(type, key, data) {
  if (type == 'session') {
    window.sessionStorage.setItem(key, data);
  } else {
    window.localStorage.setItem(key, data);
  }
};

export const getItem = function(type, key) {
  if (type == 'session') {
    return window.sessionStorage.getItem(key);
  } else {
    return window.localStorage.getItem(key);
  }
};
export const removeItem = function(type, key) {
  if (type == 'session') {
    window.sessionStorage.removeItem(key);
  } else {
    window.localStorage.removeItem(key);
  }
};

export const objToLabels = function(obj, del) {
  let keywordLabels = []; /* 关键词 */
  let locationLabels = []; /* 地区 */
  let industryLabels = []; /* 行业一级 */
  let subindustryLabels = []; /* 行业二级 */
  let entStatusLabels = []; /* 营业状态 */
  let contactLabels = []; /* 联系方式 */
  let createdDateLabels = []; /* 成立年限 */
  let registerLabels = []; /* 注册资本 */
  let companysourceLabels = []; /* 企业来源 */
  let enttypeLabels = []; /* 企业类型 */
  let employeesLabels = []; /* 参保人数 */
  let labels = []; /* 高级筛选（范围招聘、网络推广、网站域名、商标、公众号） */

  if (obj.keyword) {
    let words = obj.keyword.trim().split(/\s+/);
    words.forEach(word => {
      keywordLabels.push({
        key: 'keyword',
        value: word
      });
    });
  }
  if (del && del !== '0') {
    labels.push({
      key: 'delNoContact',
      value: '有联系方式'
    });
  }
  if (obj.filter) {
    if (obj.filter.location && obj.filter.location.length > 0) {
      obj.filter.location.forEach(element => {
        locationLabels.push({
          key: 'location',
          value: filters.regionTostring(element)
        });
      });
    }
    if (obj.filter.contact && obj.filter.contact.length > 0) {
      obj.filter.contact.forEach(element => {
        if (element != '0') {
          contactLabels.push({
            key: 'contact',
            value: '联系方式: ' + filters.contactTostring(element)
          });
        }
      });
    }
    if (obj.filter.companysource && obj.filter.companysource.length > 0) {
      obj.filter.companysource.forEach(element => {
        companysourceLabels.push({
          key: 'companysource',
          value: '企业来源: ' + filters.sourceToString(element)
        });
      });
    }
    if (obj.filter.industryshort && obj.filter.industryshort.length > 0) {
      // console.log(obj.filter.industryshort);
      // console.log(obj.filter.industryshort.length);
      let industryshorts = obj.filter.industryshort.map(item => {
        //options.industryMap[item]
        let reserveMath = options.industryMapMathResver[item];
        return {
          key: 'industry',
          value: '所属行业: ' + options.industryMap[reserveMath]
        };
      });
      industryLabels = [...industryLabels, ...industryshorts];
    }
    //二级
    if (
      obj.filter.secindustryshort &&
      obj.filter.secindustryshort != '0' &&
      obj.filter.secindustryshort.length > 0
    ) {
      let secindustryshort = obj.filter.secindustryshort.map(item => {
        return {
          key: 'secindustryshort',
          value: '所属行业: ' + options.industrySubMap[item]
        };
      });
      subindustryLabels = [...subindustryLabels, ...secindustryshort];
    }
    if (
      obj.filter.registercapital &&
      obj.filter.registercapital != '0' &&
      obj.filter.registercapital.length > 0
    ) {
      obj.filter.registercapital.forEach(element => {
        if (element != '0') {
          registerLabels.push({
            key: 'capital',
            value: '注册资本:' + filterCapital(element)
          });
        }
      });
    }
    if (
      obj.filter.establishment &&
      obj.filter.establishment != '0' &&
      obj.filter.establishment.length > 0
    ) {
      obj.filter.establishment.forEach(element => {
        if (element != '0') {
          createdDateLabels.push({
            key: 'date',
            value: '成立年限:' + filterEstablishDate(element)
          });
        }
      });
      // labels.push({
      //   key: 'date',
      //   value: '成立年限:' + filterEstablishDate(obj.filter.establishment)
      // });
    }
    if (
      obj.filter.entstatus &&
      obj.filter.entstatus != '0' &&
      obj.filter.entstatus.length > 0
    ) {
      obj.filter.entstatus.forEach(element => {
        if (element != '0') {
          entStatusLabels.push({
            key: 'entstatus',
            value: '营业状态:' + options.entstatusMap[element]
          });
        }
      });
    }
    if (
      obj.filter.enttype &&
      obj.filter.enttype != '0' &&
      obj.filter.enttype.length > 0
    ) {
      obj.filter.enttype.forEach(element => {
        if (element != '0') {
          enttypeLabels.push({
            key: 'enttype',
            value: '企业类型:' + options.enttypeMap[element]
          });
        }
      });
    }
    if (
      obj.filter.employees &&
      obj.filter.employees != '0' &&
      obj.filter.employees.length > 0
    ) {
      obj.filter.employees.forEach(element => {
        if (element != '0') {
          const value = _get(
            _find(options.employeesMap, i => i.key == element),
            'value',
            ''
          );
          if (value)
            employeesLabels.push({
              key: 'employees',
              value: '参保人数:' + options.employeesMap[element].value
            });
        }
      });
    }
    /* 高级筛选（范围招聘、网络推广、网站域名、商标、公众号） */

    if (obj.scope && obj.scope != '0') {
      labels.push({
        key: 'scope',
        value: '搜索范围:' + options.scopeMap[obj.scope]
      });
    }

    if (obj.filter.hasrecruit && obj.filter.hasrecruit != '0') {
      labels.push({
        key: 'hasrecruit',
        value:
          '招聘情况:' +
          (obj.filter.hasrecruit == '1' ? '有招聘信息' : '无招聘信息')
      });
    }
    if (obj.filter.hassem && obj.filter.hassem != '0') {
      labels.push({
        key: 'hassem',
        value:
          '网络推广:' + (obj.filter.hassem == '1' ? '有网络推广' : '无网络推广')
      });
    }
    if (obj.filter.haswebsite && obj.filter.haswebsite != '0') {
      labels.push({
        key: 'haswebsite',
        value:
          '网站域名:' + (obj.filter.haswebsite == '1' ? '有域名' : '无域名')
      });
    }
    if (obj.filter.hastrademark && obj.filter.hastrademark != '0') {
      labels.push({
        key: 'hastrademark',
        value: '商标:' + (obj.filter.hastrademark == '1' ? '有商标' : '无商标')
      });
    }
    if (obj.filter.haspatent && obj.filter.haspatent != '0') {
      labels.push({
        key: 'haspatent',
        value: '专利:' + (obj.filter.haspatent == '1' ? '有专利' : '无专利')
      });
    }
    if (obj.filter.hastender && obj.filter.hastender != '0') {
      labels.push({
        key: 'hastender',
        value:
          '招投标:' + (obj.filter.hastender == '1' ? '有招投标' : '无招投标')
      });
    }

    if (obj.filter.haswechataccnt && obj.filter.haswechataccnt != '0') {
      labels.push({
        key: 'haswechataccnt',
        value:
          '公众号:' +
          (obj.filter.haswechataccnt == '1' ? '有公众号' : '无公众号')
      });
    }
    if (obj.isFromMap) {
      labels.push({
        key: 'isFromMap',
        value: '地图搜索'
        //  + options.scopeMap[obj.scope]
      });
    }
    if (obj.filter.sortBy && obj.filter.sortBy !== '0') {
      labels.push({
        key: 'sortBy',
        value: options.sortByMap[obj.filter.sortBy]
      });
    }
  }
  return {
    keywordLabels,
    locationLabels,
    industryLabels,
    subindustryLabels,
    entStatusLabels,
    contactLabels,
    createdDateLabels,
    registerLabels,
    companysourceLabels,
    enttypeLabels,
    employeesLabels,
    labels
  };
};

export const filterCapital = value => {
  if (value) {
    if (value.indexOf(',') != -1) {
      const arr = value.split(',');
      if (arr[0] && arr[1]) {
        return arr[0] + ' ~ ' + arr[1] + '万';
      } else if (arr[0] && !arr[1]) {
        return arr[0] + '万以上';
      } else {
        return arr[1] + '万以下';
      }
    } else {
      return options.capitalMap[value];
    }
  } else {
    return '-';
  }
};

export const filterEstablishDate = value => {
  // if (value) {
  //   /*  console.log(value);*/
  //   if (value.indexOf(',') != -1) {
  //     const arr = value.split(',');
  //     if (arr[0] && arr[1]) {
  //       return arr[0] + '-' + arr[1] + '年';
  //     } else if (arr[0] && !arr[1]) {
  //       return arr[0] + '年以上';
  //     } else {
  //       return arr[1] + '年以内';
  //     }
  //   } else {
  //     return options.createDateMap[value];
  //   }
  // } else {
  //   return '-';
  // }
  if (value) {
    if (value.indexOf('-') != -1) {
      const arr = value.split('-');
      arr[0] = filters.dateFormat(arr[0], 'yyyy/MM/dd');
      arr[1] = filters.dateFormat(arr[1], 'yyyy/MM/dd');
      if (arr[0] && arr[1]) {
        return arr[0] + '-' + arr[1];
      } else if (arr[0] && !arr[1]) {
        return arr[0];
      } else {
        return arr[1];
      }
    } else if (value.indexOf(',') != -1) {
      const arr = value.split(',');
      if (arr[0] && arr[1]) {
        return arr[0] + '-' + arr[1] + '年';
      } else if (arr[0] && !arr[1]) {
        return arr[0] + '年以上';
      } else {
        return arr[1] + '年以内';
      }
    } else {
      // return value.indexOf(',') != -1
      //   ? options.createDateMap[value.split(',')[0]]
      //   : options.createDateMap[value];
      return options.createDateMap[value];
    }
  } else {
    return '-';
  }
};

export function getStrLen(str) {
  let len = 0;
  let c;
  for (let i = 0; i < str.length; i++) {
    c = str.charCodeAt(i);
    if (isDbcCase(c)) {
      //半角
      len = len + 1;
    } else {
      //全角
      len = len + 2;
    }
  }
  return len;
}

/**
 * 函数名：判断字符是全角还是半角
 * 函数说明：判断字符是全角还是半角
 * @param c 字符
 * @return true：半角 false：全角
 */

function isDbcCase(c) {
  // 基本拉丁字母（即键盘上可见的，空格、数字、字母、符号）
  if (c >= 32 && c <= 127) {
    return true;
  } else if (c >= 65377 && c <= 65439) {
    // 日文半角片假名和符号
    return true;
  }
  return false;
}
/*手机号格式验证*/
export const validatePass = (rule, value, callback) => {
  const regex = /^1\d{10}$/;
  if (value === '') {
    callback(new Error('请输入电话号码'));
  } else {
    if (regex.test(value)) {
      callback();
    } else {
      callback(new Error('请输入正确的电话号码'));
    }
  }
};

export const clearLocalStorage = (excludeTmp, excludeVerify) => {
  removeItem('local', 'twe_logged');
  removeItem('local', 'twe_userInfo');
  removeItem('local', 'mode');
  removeItem('local', 'seasize');
  removeItem('local', 'searchsize');
  removeItem('local', 'recyclesize');
  removeItem('local', 'callRecordSize');
  removeItem('local', 'poolsize');
  removeItem('local', 'tasksize');
  removeItem('local', 'usersize');
  removeItem('local', 'approvesize');
  removeItem('local', 'albumsize');
  removeItem('local', 'click');
  removeItem('local', 'newCompanyHint');
  removeItem('local', 'expired_logged');
  removeItem('session', 'isDtAppLogin');
  removeItem('local', 'setPwdUser');
  removeItem('local', 'logo');
  if (!excludeTmp) {
    removeItem('local', 'tmp_logged');
  }
  if (!excludeVerify) {
    removeItem('local', 'seenVerify');
  }
};

export const getOrigin = () => {
  let Origin = '';
  if (!window.location.origin) {
    //兼容IE10
    Origin =
      window.location.protocol +
      '//' +
      window.location.hostname +
      (window.location.port ? ':' + window.location.port : '');
  } else {
    Origin = window.location.origin;
  }
  return Origin;
};

export const RegistCall = () => {
  let now = new Date().getTime() + Math.random();
  let token = localStorage.getItem('twe_logged');
  if (token) {
    token = token.split(' ')[1];
    window['Regist'] = res => {
      if (res.code == 0) {
        sessionStorage.setItem('callRegisted', 1);
      } else {
        console.log('注册失败');
      }
      window['getConnected' + this._uid] = null;
    };
    let Origin = getOrigin();
    console.log('regist', Origin);
    let url =
      'https://localhost:10081/JD_reg_client?_=' +
      now +
      '&callback=Regist' +
      '&name=Sos121' +
      '&pushurl=' +
      Origin +
      '/api/callRecord/receiveCallRecord?token=' +
      token;
    let body = document.getElementsByTagName('body')[0];
    let script = document.createElement('script');
    script.setAttribute('src', url);
    script.setAttribute('id', 'connect');
    body.appendChild(script);
    let ele = document.getElementById('connect');
    body.removeChild(ele);
  }
};

//滚动条在Y轴上的滚动距离
export const getScrollTop = () => {
  var scrollTop = 0,
    bodyScrollTop = 0,
    documentScrollTop = 0;
  if (document.body) {
    bodyScrollTop = document.body.scrollTop;
  }
  if (document.documentElement) {
    documentScrollTop = document.documentElement.scrollTop;
  }
  scrollTop =
    bodyScrollTop - documentScrollTop > 0 ? bodyScrollTop : documentScrollTop;
  return scrollTop;
};

//文档的总高度
export const getScrollHeight = () => {
  var scrollHeight = 0,
    bodyScrollHeight = 0,
    documentScrollHeight = 0;
  if (document.body) {
    bodyScrollHeight = document.body.scrollHeight;
  }
  if (document.documentElement) {
    documentScrollHeight = document.documentElement.scrollHeight;
  }
  scrollHeight =
    bodyScrollHeight - documentScrollHeight > 0
      ? bodyScrollHeight
      : documentScrollHeight;
  return scrollHeight;
};

//浏览器视口的高度
export const getWindowHeight = () => {
  var windowHeight = 0;
  if (document.compatMode == 'CSS1Compat') {
    windowHeight = document.documentElement.clientHeight;
  } else {
    windowHeight = document.body.clientHeight;
  }
  return windowHeight;
};

// 根据城市名返回adcode
export const getAdcode = (name, type = 'province') => {
  if (type === 'province') {
    for (let index = 0; index < provinceMap.length; index++) {
      if (provinceMap[index].name === name) {
        return provinceMap[index].adcode;
      }
    }
  } else {
    for (let index = 0; index < cityMap.length; index++) {
      if (cityMap[index].name === name) {
        return cityMap[index].adcode;
      }
    }
  }
};
/* 根据城市adcode返回城市名称 */
export const getCityName = code => {
  if (!code) {
    return;
  }
  let newCode = code[0].padEnd(6, '0');
  if (code[0].length === 2) {
    for (let index = 0; index < provinceMap.length; index++) {
      if (provinceMap[index].adcode == newCode) {
        return provinceMap[index].name;
      }
    }
  } else {
    for (let index = 0; index < cityMap.length; index++) {
      // console.log(cityMap[index].name,code,'0_0')
      if (cityMap[index].adcode == newCode) {
        return cityMap[index].name;
      }
    }
  }
};
// 根据城市编码返回城市名称
export const getReversibleCityName = (provinces, city, county) => {
  let [
    provincesName,
    cityName,
    countyName,
    targetArr,
    targetArrCity,
    targetArrCounty
  ] = ['', '', '', [], [], []];
  try {
    targetArr = administrativeAreas.normal.filter(item => {
      return item.NUM == provinces;
    });
    provincesName = targetArr[0].NAME;
  } catch (error) {
    provincesName = '';
  }
  try {
    targetArrCity = targetArr[0].children.filter(item => {
      return item.NUM == city;
    });
    cityName = targetArrCity[0].NAME;
  } catch (error) {
    cityName = '';
  }
  try {
    targetArrCounty = targetArrCity[0].children.filter(item => {
      return item.NUM == county;
    });
    countyName = targetArrCounty[0].NAME;
  } catch (error) {
    countyName = '';
  }
  if (provincesName || cityName || countyName) {
    if (countyName) {
      return `所在地区：${cityName}${countyName ? '-' + countyName : ''}`;
    } else {
      if (provincesName == cityName && cityName != '吉林') {
        return `所在地区：${provincesName}`;
      } else {
        return `所在地区：${provincesName}${cityName ? '-' + cityName : ''}`;
      }
    }
  } else {
    return '';
  }
};

//webSocket提示处理
export const showOperateMessage = (operate, result, userInfo, vue) => {
  console.log(result);
  if (operate === 'add' || operate === 'delete') {
    showAddMessage(operate, result, userInfo, vue);
  }
  if (operate === 'export' || operate === 'assignTask') {
    showExportMessage(operate, result, userInfo, vue);
  }
  if (operate === 'transferClue') {
    showTransferClueMessage(operate, result, userInfo, vue);
  }
};
const showAddMessage = (operate, result, userInfo, vue) => {
  let myClueName = window.localStorage.getItem('isCluePoolName');
  if (result.success) {
    if (result.message_local) {
      vue.$message({
        message:
          result.error_code === 0
            ? '批量同步数据已上传，等待' + userInfo.systemName + '处理'
            : result.message_local,
        type: 'success',
        duration: 5000
      });
      if (result.data.isExceedLimit) {
        setTimeout(() => {
          vue.$message({
            message: `${
              myClueName ? myClueName : '线索池'
            }容量已满，此时只会同步部分数据`,
            type: 'success',
            duration: 3000
          });
        }, 2000);
      }
    } else {
      let mes = operate == 'add' ? '成功添加线索' : '成功删除线索！';
      if (result.data.successCount) {
        mes =
          operate == 'add'
            ? '成功添加' +
              result.data.successCount +
              '条线索！' +
              (result.data.isExceedLimit
                ? `（${myClueName ? myClueName : '线索池'}容量已达上限）`
                : '')
            : '成功删除' + result.data.successCount + '条线索！';
      }
      vue.$message.success(mes);
    }
  } else {
    if (result.message_local) {
      vue.$message({
        message: result.message_local,
        type: 'error',
        duration: 5000
      });
    } else if (result.error_code == '6006') {
      vue.$message.error(errorCode[result.error_code]);
    } else {
      let mess =
        operate == 'add' ? '添加线索失败！请稍后重试' : '删除失败！请稍后重试';
      vue.$message.error(mess);
    }
  }
};
const showExportMessage = (operate, result, userInfo, vue) => {
  if (result.success) {
    if (operate === 'assignTask') {
      vue.$message.success('成功分配' + result.data.successCount + '条线索！');
    } else {
      vue.$message.success('生成成功！请前往【导出记录】下载');
    }
  } else {
    vue.$message.error(errorCode[result.error_code]);
  }
};
const showTransferClueMessage = (operate, result, userInfo, vue) => {
  let myClueName = window.localStorage.getItem('isCluePoolName');
  if (result.success) {
    let mes = '';
    if (!result.data.isVolumeFull && result.data.successCount > 0) {
      mes = '成功转移' + result.data.successCount + '条线索！';
      vue.$message.success(mes);
    } else if (result.data.isVolumeFull) {
      if (result.data.successCount > 0) {
        mes =
          '成功转移' +
          result.data.successCount +
          `条线索（${myClueName ? myClueName : '线索池'}容量已满）`;
        vue.$message.success(mes);
      } else {
        let diverter = getItem('session', 'diverter'); //fixed 26756
        mes = diverter + `用户${myClueName ? myClueName : '线索池'}容量已满`;
        vue.$message.error(mes);
        removeItem('session', 'diverter'); //fixed 26756
      }
    } else if (!result.data.isVolumeFull && result.data.successCount <= 0) {
      vue.$message.error('没有可转移的线索');
    }
  } else {
    vue.$message.error('转移失败，请稍后重试');
  }
};

export const regionHelper = {
  normalizeDirectlyCity(location) {
    const directlyCity = ['1101', '3101', '5001', '1201']; // 北京,上海,重庆,天津
    if (location && location.length > 0) {
      location.forEach((num, i) => {
        if (directlyCity.some(directNum => directNum === num)) {
          // 当前选中城市为直辖市的市级，则替换为省级的直辖市num
          location[i] = num.slice(0, 2);
        }
      });
    }
  },

  parseParentNumPath(num) {
    let numPath = [];
    let parentNum = this.parseParentNum(num);

    // 根节点排在最后
    while (parentNum) {
      numPath.push(parentNum);
      parentNum = this.parseParentNum(parentNum);
    }

    return numPath;
  },

  parseParentNum(num) {
    if (num && num.length > 2) {
      return num.substring(0, num.length - 2);
    }
    return '';
  },

  isProvince(num) {
    return num && num.length === 2;
  },
  parseProvince(num) {
    return num && num.substring(0, 2);
  },

  isCity(num) {
    if (municipality.indexOf(num)) {
      return num && num.length === 6;
    } else {
      return num && num.length === 4;
    }
    // return num && num.length === 4;
  },
  parseCity(num) {
    if (municipality.indexOf(num)) {
      return num && num.substring(0, 6);
    } else {
      return num && num.substring(0, 4);
    }
    // return num && num.substring(0, 4);
  },

  isDistrict(num) {
    return num && num.length === 6;
  }
};

export function getPublicName() {
  let localName = window.localStorage.getItem('publicSeaName');
  return localName ? localName : '公海';
}

// 获取今日零点时间
export function zeroSecondTime() {
  let date = new Date();
  let m = date.getMonth() + 1;
  let zstr = date.getFullYear() + '/' + m + '/' + date.getDate();
  let zt = new Date(zstr).getTime();
  return Math.floor(zt / 1000);
}

// 判断数据是否为空
export function isEmpty(val) {
  if (
    typeof val == 'boolean' ||
    typeof val == 'number' ||
    lodashModel.isDate(val)
  ) {
    // bool 或 数字 或 日期的就返回false
    return false;
  }
  if (typeof val == 'string' && val.toLocaleLowerCase() == 'null') {
    // null字符串返回false
    return false;
  }
  return lodashModel.isEmpty(val);
}

// 时间戳转日期
export function dateFormat(at) {
  let time = new Date(parseInt(at));
  let y = time.getFullYear();
  let m = time.getMonth() + 1;
  let d = time.getDate();
  let h = time.getHours();
  let mm = time.getMinutes();
  let s = time.getSeconds();
  return (
    y +
    '-' +
    add0(m) +
    '-' +
    add0(d) +
    ' ' +
    add0(h) +
    ':' +
    add0(mm) +
    ':' +
    add0(s)
  );
}

export function add0(m) {
  return m < 10 ? '0' + m : m;
}

// 设置默认颜色
export function siteColorHandle(colorData) {
  colorData = isEmpty(colorData) ? {} : colorData;

  for (let k in SITE_COLOR_DEFAULT) {
    colorData[k] =
      !(k in colorData) || isEmpty(colorData[k])
        ? SITE_COLOR_DEFAULT[k]
        : colorData[k];
  }
  return colorData;
}

// 深度拷贝
export function deepClone(data) {
  return lodashModel.cloneDeep(data);
}



// WEBPACK FOOTER //
// ./src/common/utils.js